export function AllowedProfiles(
  profileName: string | undefined,
  allowed: string[],
): boolean {
  return allowed.includes(profileName ?? '');
}
